import { combineReducers } from 'redux';
import user from './user_reducer';

export default combineReducers( { user } );


// WEBPACK FOOTER //
// ./src/reducers/index.js